import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PublicHeader } from "@/components/PublicHeader";
import { Loader2 } from "lucide-react";

/** Páginas públicas /termos e /privacidade (texto cadastrado em Configurações → Escola). */
export default function LegalPage({ kind }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/public/school").then((r) => setS(r.data)).catch(() => setS({})); }, []);
  const html = kind === "termos" ? s?.terms_html : s?.privacy_html;
  const title = kind === "termos" ? "Contrato e Termos de Uso" : "Política de Privacidade";
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <PublicHeader />
      <main className="max-w-3xl mx-auto px-5 py-10">
        <h1 className="font-display text-3xl font-bold text-slate-900">{title}</h1>
        {s?.name && <p className="text-sm text-slate-500 mt-1">{s.name}{s.cnpj ? ` · CNPJ ${s.cnpj}` : ""}</p>}
        <div className="bg-white border border-slate-200 rounded-2xl p-6 mt-6">
          {s === null ? <Loader2 className="h-5 w-5 animate-spin text-slate-400" />
            : html ? <div className="lesson-html text-slate-700 text-[15px]" dangerouslySetInnerHTML={{ __html: html }} />
            : <p className="text-slate-500">Documento ainda não publicado.</p>}
        </div>
        <p className="text-sm text-slate-500 mt-6">
          {kind === "termos" ? <Link to="/privacidade" className="text-[#1E9E2A] hover:underline">Política de Privacidade</Link> : <Link to="/termos" className="text-[#1E9E2A] hover:underline">Contrato e Termos de Uso</Link>}
          {s?.support_email && <> · Dúvidas: <a href={`mailto:${s.support_email}`} className="text-[#1E9E2A] hover:underline">{s.support_email}</a></>}
        </p>
      </main>
    </div>
  );
}
